import { useContext } from 'react'
import PositionContext from './positionContext'
/*
Copyright 2022-06-16 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: Se agrega CarrierContext
*/

export const usePosition = () => {
  const context = useContext(PositionContext)
  if (context === undefined) {
    throw new Error('useCarrier must be used with a Provider')
  }

  return context
}

export default usePosition
